import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {LawPage} from './components/LawPage';
import {ContentRoute, LayoutSplashScreen} from '../../../_metronic/layout';

export default function LawPageContainer() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/lawsuit" component={LawPage}/>
      </Switch>
    </Suspense>
  );
}
